// Accordion for product
$(function() {
    // (Optional) Active an item if it has the class "is-active"	
    $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();

    $(".accordion > .accordion-item").click(function() {
        // Chiudiamo gli altri pannelli
        $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
        
        // Toggle del pannello corrente
        $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out", function() {
            // Dopo che il pannello si è espanso o contratto, scorri verso l'accordion aperto (se è attivo) con un offset di 200 pixel
            if ($(this).parent(".accordion-item").hasClass("is-active")) {
                var accordionOffset = $(this).parent(".accordion-item").offset().top - 200; // Aggiungiamo l'offset di 200 pixel
                $("html, body").animate({ scrollTop: accordionOffset }, "slow");
            }
        });
    });
});